module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/main_pc_0b27bb27a8c95ec3e5079ba51d034e2e.jpg";